import React from 'react'
import { Profile } from '../../components'

const About = () => {
  return (
    <div>
      <Profile />
    </div>
  )
}

export default About
